import type { InputHTMLAttributes, ReactNode, TextareaHTMLAttributes } from "react";

type FieldWrapProps = { label?: string; htmlFor?: string; children: ReactNode };

export function FieldWrap({ label, htmlFor, children }: FieldWrapProps) {
  return (
    <div className="field">
      {label && <label htmlFor={htmlFor}>{label}</label>}
      {children}
    </div>
  );
}

export function Input({ className = "", ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={`input ${className}`.trim()} {...props} />;
}

export function Textarea({ className = "", ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={`input ${className}`.trim()} {...props} />;
}
